module.exports = __webpack_public_path__ + "img/from_toeic_content.2351a271.svg";